import React from 'react';
import { OneTimeTooltipNativeLanguageButtonHOC } from '../../hocs/OneTimeTooltipNativeLanguageHOC/OneTimeTooltipNativeLanguageButtonHOC';

export const OneTimeTooltipNativeLanguageButtonConnected = () => {
	return (
		<OneTimeTooltipNativeLanguageButtonHOC />
	);
}
